"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("fabric");
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var StaticVectorObject = /** @class */ (function (_super) {
    __extends(StaticVectorObject, _super);
    function StaticVectorObject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.objectColors = {};
        _this.colorMap = {};
        return _this;
    }
    StaticVectorObject.prototype.updateLayerColor = function (prev, next) {
        var _a;
        var sameObjects = this.objectColors[prev];
        if (sameObjects) {
            sameObjects.forEach(function (c) {
                c.fill = next;
            });
            (_a = this.canvas) === null || _a === void 0 ? void 0 : _a.requestRenderAll();
            // @ts-ignore
            this.colorMap[prev] = next;
        }
    };
    //@ts-ignore
    StaticVectorObject.prototype.initialize = function (objects, options, others) {
        var existingColorMap = others.colorMap;
        var objectColors = (0, groupBy_1.default)(objects, "fill");
        // set colorMap
        if (existingColorMap) {
            Object.keys(existingColorMap).forEach(function (color) {
                var colorObjects = objectColors[color];
                if (colorObjects) {
                    // @ts-ignore
                    colorObjects.forEach(function (c) {
                        c.fill = existingColorMap[color];
                    });
                }
            });
        }
        this.objectColors = objectColors;
        var colorMap = {};
        Object.keys(objectColors).forEach(function (c) {
            colorMap[c] = c;
        });
        if (existingColorMap) {
            Object.keys(existingColorMap).forEach(function (c) {
                colorMap[c] = existingColorMap[c];
            });
        }
        this.colorMap = colorMap;
        var object = fabric_1.fabric.util.groupSVGElements(objects, options);
        //@ts-ignore
        _super.prototype.initialize.call(this, [object], __assign(__assign({}, others), { colorMap: colorMap }));
        this.set("src", others.src);
        return this;
    };
    StaticVectorObject.prototype.toObject = function (propertiesToInclude) {
        if (propertiesToInclude === void 0) { propertiesToInclude = []; }
        // @ts-ignore
        return _super.prototype.toObject.call(this, propertiesToInclude, {
            src: this.src,
        });
    };
    StaticVectorObject.prototype.toJSON = function (propertiesToInclude) {
        if (propertiesToInclude === void 0) { propertiesToInclude = []; }
        // @ts-ignore
        return _super.prototype.toObject.call(this, propertiesToInclude, {
            src: this.src,
        });
    };
    StaticVectorObject.fromObject = function (options, callback) {
        fabric_1.fabric.loadSVGFromURL(options.src, function (objects, opts) {
            return callback && callback(new fabric_1.fabric.StaticVector(objects, opts, __assign({}, options)));
        });
    };
    StaticVectorObject.type = "StaticVector";
    return StaticVectorObject;
}(fabric_1.fabric.Group));
fabric_1.fabric.StaticVector = fabric_1.fabric.util.createClass(StaticVectorObject, {
    type: StaticVectorObject.type,
});
fabric_1.fabric.StaticVector.fromObject = StaticVectorObject.fromObject;
exports.default = StaticVectorObject;
